import { render } from "./TemplatesDownload.vue?vue&type=template&id=69371d20&scoped=true&ts=true"
import script from "./TemplatesDownload.vue?vue&type=script&lang=ts"
export * from "./TemplatesDownload.vue?vue&type=script&lang=ts"

import "./TemplatesDownload.vue?vue&type=style&index=0&id=69371d20&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69371d20"]])

export default __exports__